import { createAction } from '@reduxjs/toolkit';
import { User } from '../auth/actions';

export interface Employee {
    id?: number;
    user?: User;
    hour_rate?: number;
    weekly_cap?: number;
    payouts?: number;
    avatar?: string;
    stores?: number[];
    teams?: number[];
    contract_type?: string;
}

export const listEmployeesRequest = createAction<{filters: string, members_fields: string, excludes: string}>('employee/listRequest');
export const listEmployeesSuccess = createAction<Employee[]>('employee/listSuccess');
export const listEmployeesFailure = createAction<string>('employee/listFailure');

export const createEmployeeRequest = createAction<{employee: Employee, update_fields: string[], members_fields?: string}>('employee/createEmployeeRequest');

export const getEmployeeRequest = createAction<{id: number, members_fields: string}>('employee/getRequest');
export const setEmployeeRequest = createAction<Employee|null>('employee/setRequest');
export const getEmployeeSuccess = createAction<Employee|null>('employee/getSuccess');
export const getEmployeeFailure = createAction<string>('employee/getFailure');

export const updateEmployeeRequest = createAction<{employee: Employee, update_fields: string[], members_fields?: string}>('employee/updateEmployeeRequest');
export const updateEmployeesRequest = createAction<{employees: Employee[], update_fields: string[], members_fields?: string}>('employee/updateEmployeesRequest');
export const updateEmployeesSuccess = createAction<Employee[]>('employee/updateEmployeesSuccess');
export const updateEmployeesFailure = createAction<string>('employee/updateEmployeesFailure');

export const resetErrorRequest = createAction('employee/resetErrorRequest');
